import { AppContentListItem } from "JS/React/Components/AppContentListItem";
import { CSSProperties } from "react";
import { Content, Course, ReceivedGift } from "JS/Models";

export interface SpeakerPlaylistRowItemProps {
    index: number;
    style: CSSProperties;
    listItem: ReceivedGift | Content | Course;
    imageUrl: string;
    handleToogleCheckBox?: (nid: string, value: boolean) => void;
    isCheckedItem: boolean;
}

export const SpeakerPlaylistRowItem = (props: SpeakerPlaylistRowItemProps) => {
    const {
        index,
        style,
        listItem,
        isCheckedItem,
        handleToogleCheckBox,
        imageUrl,
    } = props;

    return (
        <AppContentListItem
            style={style}
            key={`${listItem.nid}-${index}`}
            nid={listItem.nid}
            skuId={listItem.sku_id}
            description={listItem.description}
            imageUrl={imageUrl}
            title={listItem.title}
            acquiredDate={"acquired_date" in listItem && listItem.acquired_date}
            releaseDate={"release_date" in listItem && listItem.release_date}
            handleToogleCheckBox={handleToogleCheckBox}
            isCheckedItem={isCheckedItem}
            isFromSpeakerPlaylist={true}
        />
    );
};
